import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-04c8f234"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header_container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header_logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["src"]

import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
  activeIndex: Number,
  theme: String
},
  emits: ['trigger'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const props = __props
const router = useRouter()
const route = useRoute()
// temp1.path

const handleTrigger = (index: number) => {
  if (route.path === '/') {
    emit('trigger', index)
  } else {
    router.push({ name: 'Home', params: { index } })
  }
}
const theme = ref()
watch(() => route.path, (path) => {
  if (path !== '/') {
    theme.value = 'dark'
  }
})

//激活的导航项类
const activeNavItemClass = (index: number) => {
  if (index === 2 && [2, 3, 4].includes((props.activeIndex as any))) return 'header_navItem-active';

  return props.activeIndex === index ? 'header_navItem-active' : ''
}

//非首页状态
const noHomeState = computed(() => props.activeIndex !== 0);
const noHomeStyle = computed(() => {
  if (theme.value === 'dark') return '';
  return noHomeState.value ? 'background-color: #fff;color:#000' : ''
})


//菜单按钮
const menuBtnIcon = computed(() => {
  return props.activeIndex !== 0 ? require('./menu.svg') : require('./menu-w.svg')
})

//菜单是否打开
const mql = ref(window.matchMedia('(max-width: 768px)'))
const isPhone = ref(false);
const isOpenMenu = ref(false);
watch(() => props.activeIndex, () => {
  isOpenMenu.value = false
})
const navMenuStyle = computed(() => {
  return isPhone.value && isOpenMenu.value ? '' : isPhone.value ? 'display: none' : ''
})
const handleMqlChange = (e: any) => {
  isPhone.value = e.matches
}
onMounted(() => {
  isPhone.value = mql.value.matches;
  mql.value.addEventListener('change', handleMqlChange)
})
onUnmounted(() => {
  mql.value.removeEventListener('change', handleMqlChange)
})





return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: "header",
    style: _normalizeStyle([noHomeStyle.value])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "header_indexLink",
        to: "/",
        style: _normalizeStyle([noHomeStyle.value])
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "header_logoContainer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('trigger', 0)))
          }, _hoisted_3),
          _createElementVNode("h1", {
            class: "header_title",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('trigger', 0)))
          }, "网格智能")
        ]),
        _: 1
      }, 8, ["style"]),
      _createElementVNode("nav", {
        class: "header_nav",
        style: _normalizeStyle([noHomeStyle.value, navMenuStyle.value])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["header_navItem", activeNavItemClass(0)]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (handleTrigger(0)))
        }, "首页", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["header_navItem", activeNavItemClass(1)]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (handleTrigger(1)))
        }, "应用案例", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["header_navItem", activeNavItemClass(2)]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (handleTrigger(2)))
        }, "智联终端", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["header_navItem", activeNavItemClass(5)]),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (handleTrigger(5)))
        }, "合作单位", 2),
        _createElementVNode("div", {
          class: _normalizeClass(["header_navItem", activeNavItemClass(6)]),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (handleTrigger(6)))
        }, "联系我们", 2)
      ], 4),
      (isPhone.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "header_menuBtn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (isOpenMenu.value = !isOpenMenu.value))
          }, [
            _createElementVNode("img", {
              class: "header_menuBtnIcon",
              src: menuBtnIcon.value
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 4))
}
}

})